<template>
  <v-container fluid fill-height>
    <v-btn flat @click="exit()"
      ><v-icon>arrow_back_ios</v-icon>&nbsp;Back</v-btn
    >
    <v-layout justify-center align-center>
      <v-flex xs12 sm6 lg4>
        <v-form ref="contactform" v-model="valid" lazy-validation>
          <v-text-field
            v-model="contact.email"
            :rules="emailRules"
            label="Email"
            required
          ></v-text-field>

          <v-text-field
            v-model="contact.phone"
            :rules="[(v) => v.length === 10 || 'A phone number is required']"
            mask="###-###-####"
            label="Phone Number"
            required
          ></v-text-field>

          <v-text-field
            v-model="contact.organization"
            label="Organization"
          ></v-text-field>
        </v-form>
      </v-flex>
      <v-flex xs12 sm5 lg4>
        <div class="text-lg-center">
          <v-btn dark color="primary" @click="submit">submit</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "ContactPOG",

  props: {
    inputContact: Object,
  },

  beforeMount() {
    // Update with previous contact info
    Object.keys(this.inputContact).forEach((key) => {
      if (this.inputContact[key]) {
        this.contact[key] = this.inputContact[key];
      }
    });
  },

  data() {
    return {
      valid: true,
      emailRules: [
        (v) => !!v || "An email address is required",
        (v) => /.+@.+/.test(v) || "Email must be valid",
      ],

      contact: {
        email: null,
        phone: "",
        organization: null,
      },
    };
  },

  methods: {
    exit() {
      this.$emit("update-contact", null);
    },
    submit() {
      if (this.$refs.contactform.validate()) {
        this.$emit("update-contact", this.contact);
      }
    },
  },
};
</script>

<style scoped>
</style>
